// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bbb_a","InstagramEmbed__mask":"bbb_b bhu_bi bhu_bo bhu_vt"};